<template>
  <div class="mcf-window">
    <div class="mcf-header">
      <div class="mcf-header-left">
        <div class="mcf-header-left-menu">
          <i class="fa fa-grip"></i>
        </div>
        <div class="mcf-header-left-title">
          <label>{{title}}</label>
        </div>
      </div>
      <div class="mcf-header-center">
        <div class="mcf-search">
          <div class="mcf-search-icon">
            <i class="fa fa-search"></i>
          </div>
          <div class="mcf-search-content">
            <input type="text" v-model="txtsearch" placeholder="Rechercher ou scanner un produit" v-on:keyup.enter="evt_search_enter">
          </div>
        </div>
      </div>
      <div class="mcf-header-right">
        <ul>
          <li><label>{{lg[form.state]}}</label></li>
          <li><i class='fa fa-user'></i></li>
        </ul>
      </div>
    </div>
    <div class="mcf-appwindow">
      <div class="mcf-ribbon">
        <div class="mcf-ribbon-left">
          <div class="mcf-ribbon-group" v-if="!is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button class="mcf-ribbon-button-new">
                <i class="fa fa-plus"></i>
                <label>Nouveau</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Facture</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_new" class="mcf-ribbon-button-new">
                <i class="fa fa-plus"></i>
                <label>Nouveau</label>
              </button>
              <button @click="bt_print" class="mcf-ribbon-button-large">
                <i class="fa fa-print"></i>
                <label>Imprimer</label>
              </button>
              <button class="mcf-ribbon-button-large">
                <i class="fa fa-envelope"></i>
                <label>Envoyer</label>
              </button>
              <button @click="bt_delete" :class="{'mcf-ribbon-button-large':is_editable,'mcf-ribbon-button-large-disabled':!is_editable}">
                <i class="fa fa-trash"></i>
                <label>Supprimer</label>
              </button>
              <button @click="bt_validate" :class="{'mcf-ribbon-button-large':is_editable,'mcf-ribbon-button-large-disabled':!is_editable}">
                <i class="fa fa-check"></i>
                <label>Valider</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Facture</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_customer_selection" :class="{'mcf-ribbon-button-large':is_editable,'mcf-ribbon-button-large-disabled':!is_editable}">
                <i class="fa fa-address-book"></i>
                <label>Sélection</label>
              </button>
              <button @click="bt_customer_fast" :class="{'mcf-ribbon-button-large':is_editable,'mcf-ribbon-button-large-disabled':!is_editable}">
                <i class="fa fa-user"></i>
                <label>Passage</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Client</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_add_line" :class="{'mcf-ribbon-button-large':is_editable,'mcf-ribbon-button-large-disabled':!is_editable}">
                <i class="fa fa-plus"></i>
                <label>Ligne</label>
              </button>
              <button @click="bt_add_products" :class="{'mcf-ribbon-button-large':is_editable,'mcf-ribbon-button-large-disabled':!is_editable}">
                <i class="fa fa-boxes-stacked"></i>
                <label>Produits</label>
              </button>
              <button @click="bt_add_comment" :class="{'mcf-ribbon-button-large':is_editable,'mcf-ribbon-button-large-disabled':!is_editable}">
                <i class="far fa-comment-alt"></i>
                <label>Commentaire</label>
              </button>              
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Ajouter</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_edit_discount" :class="{'mcf-ribbon-button-large':is_editable,'mcf-ribbon-button-large-disabled':!is_editable}">
                <i class="fas fa-tag disabled"></i>
                <label>Remises</label>
              </button>
              <button @click="bt_credit" :class="{'mcf-ribbon-button-large':is_enable_credit,'mcf-ribbon-button-large-disabled':!is_enable_credit}">
                <i class="fa fa-file-invoice"></i>
                <label>Avoir</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Finances</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_add_payment" :class="{'mcf-ribbon-button-large':is_enable_payment,'mcf-ribbon-button-large-disabled':!is_enable_payment}">
                <i class="fa fa-plus"></i>
                <label>Payer</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Règlement</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_links">
            <div class="mcf-ribbon-group-buttons">
              <button v-if="is_origin" @click="bt_view_sale(form.lists.origin[0])" class="mcf-ribbon-button-large">
                <i class="fa fa-search"></i>
                <label>{{lg[form.lists.origin[0].doclabel]}}</label>
              </button>
              <button v-if="!is_enable_credit" @click="bt_view_invoice(form.id_invoice)" class="mcf-ribbon-button-large">
                <i class="fa fa-search"></i>
                <label>Facture</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Liens</label>
            </div>
          </div>
        </div>
        <div class="mcf-ribbon-right">
          <div class="mcf-ribbon-group">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_close" class="mcf-ribbon-button-large">
                <i class="fa fa-close"></i>
                <label>Fermer</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Application</label>
            </div>
          </div>
        </div>
      </div>
      <div class="mcf-appwindow-content">
        <div class="mcf-page" v-if="is_form_active">
          <div class="mcf-page-line-2">
            <div @click="bt_edit('company')" class="mcf-page-line-cell mcf-page-line-edit">
              <label class="mcf-page-line-subtitle">Votre société</label>
              <h1>{{form.company}}</h1>
              <label>{{form.address1}}</label>
              <label>{{form.zipcode}} {{form.city}}</label>
              <label>{{form.phone}} - {{form.email}}</label>
            </div>
            <div @click="bt_edit('document')" style="text-align:right;" class="mcf-page-line-cell mcf-page-line-edit">
              <label class="mcf-page-line-subtitle">Document</label>
              <h1>{{lg[form.label]}} {{form.invoice_number}}</h1>
              <label>Date: <strong>{{$filters.mdate(form.invoice_date,lang)}}</strong></label>
              <label v-if="form.label!='LBL_CREDIT'">Règlement: <strong>{{form.terms_condition}}</strong></label>
            </div>
          </div>
          <div style="margin-top:40px;" class="mcf-page-line-1">
            <div class="mcf-page-line-title">
              <h1><i class='fa fa-user'></i> Client</h1>
            </div>
          </div>
          <div class="mcf-page-line-3-c" v-if="form.cust_deliverycompany=='' && form.cust_billingcompany==''">
            <div style="justify-self: right;" class="mcf-page-line-3-c-button">
              <button @click="bt_customer_selection">
                <i class="fa fa-address-book"></i> 
                <label>Sélection</label>
              </button>
            </div>
            <div style="justify-self: center;" class="mcf-page-line-3-c-label">
              <label>ou</label>
            </div>
            <div @click="bt_edit('customer')" class="mcf-page-line-3-c-button">
              <button>
                <i class="fa fa-user"></i> 
                <label>Passage</label>
              </button>
            </div>            
          </div>
          <div class="mcf-page-line-2" v-if="form.cust_deliverycompany!='' && form.cust_billingcompany!=''">
            <div @click="bt_edit('customer')" style="text-align:center;" class="mcf-page-line-cell mcf-page-line-edit">
              <label class="mcf-page-line-subtitle">adresse de livraison</label>
              <h1>{{form.cust_deliverycompany}}</h1>
              <label>{{form.cust_deliveryaddress1}}</label>
              <label>{{form.cust_deliveryzipcode}} {{form.cust_deliverycity}}</label>
              <label>{{form.cust_deliveryphone}}</label>
            </div>
            <div @click="bt_edit('customer')" style="text-align:center;" class="mcf-page-line-cell mcf-page-line-edit">
              <label class="mcf-page-line-subtitle">adresse de facturation</label>
              <h1>{{form.cust_billingcompany}}</h1>
              <label>{{form.cust_billingaddress1}}</label>
              <label>{{form.cust_billingzipcode}} {{form.cust_billingcity}}</label>
              <label>{{form.cust_billingphone}}</label>
            </div>
          </div>
          <div style="margin-top:40px;" class="mcf-page-line-1">
            <table class="mcf-table-salelines">
              <thead>
                <tr>
                  <th v-if="is_editable" style="width:32px;text-align:center;"></th>
                  <th>Description</th>
                  <th class="mcf-table-salelines-number">Qté</th>
                  <th class="mcf-table-salelines-number">PU</th>
                  <th class="mcf-table-salelines-number">Remise</th>
                  <th class="mcf-table-salelines-number">PU remisé</th>
                  <th class="mcf-table-salelines-number">Total</th>
                </tr>
              </thead>
              <draggable v-if="list_draggable.length>0" tag="tbody" v-model="list_draggable" :sort="is_drag">
                <tr v-for="line of list_draggable" :key="line.id">
                  <template v-if="line.line_type=='PRODUCT'">
                    <td v-if="is_editable" style="width:32px;text-align:center;cursor:pointer;" @click="bt_edit_line(line)"><i class='fa fa-edit'></i></td>
                    <td style="padding:5px;text-align:left;white-space: pre-wrap;word-break: break-word;">
                      <strong>{{line.reference}}</strong>
                      <br/>
                      <label style="font-size:12px;">{{line.label}}</label>
                      <label style="font-size:12px;" v-if="line.field1!=''">Couleur : {{ line.field1 }}</label>
                      <label style="font-size:12px;" v-if="line.field2!=''">Taille : {{ line.field2 }}</label>
                    </td>
                    <td style="padding:5px;text-align:center;" class="mcf-table-salelines-number">{{$filters.number(line.qty,lang)}}</td>
                    <td style="padding:5px;text-align:right;" class="mcf-table-salelines-number">{{$filters.money(line.selling_price,lang)}}</td>
                    <td v-if="line.discount_type=='PERCENT'" style="padding:5px;text-align:right;" class="mcf-table-salelines-number">{{$filters.number(line.discount_amount,lang)}} %</td>
                    <td v-if="line.discount_type=='MONEY'" style="padding:5px;text-align:right;" class="mcf-table-salelines-number">{{$filters.money(line.discount_amount,lang)}}</td>
                    <td style="padding:5px;text-align:right;" class="mcf-table-salelines-number">{{$filters.money(line.selling_price_discounted,lang)}}</td>                  
                    <td style="padding:5px;text-align:right;" class="mcf-table-salelines-number">{{$filters.money(line.total_line,lang)}}</td>
                  </template>
                  <template v-if="line.line_type=='NOTE'">
                    <td v-if="is_editable" style="width:32px;text-align:center;cursor:pointer;" @click="bt_edit_line(line)"><i class='fa fa-edit'></i></td>
                    <td style="padding:5px;text-align:left;white-space: pre-wrap;word-break: break-word;"><strong>{{line.reference}}</strong><br/>{{line.label}}</td>
                    <td style="padding:5px;text-align:center;" colspan="5" class="mcf-table-salelines-number"></td>
                  </template>
                </tr>
              </draggable>
              <tbody v-if="list_draggable.length==0">
                <tr>
                  <td style="border:solid 1px var(--TEXT);text-align:center;padding:20px;" colspan="8"><i class='fa fa-plus'></i> Ajouter des lignes</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="margin-top:40px" class="mcf-page-line-total">
            <div @click="bt_edit('note')" class="mcf-page-line-cell mcf-page-line-edit">
              <label class="mcf-page-line-subtitle">Commentaire</label>
              <span v-if="form.note!=''">{{form.note}}</span>
              <span v-if="form.note==''">Veuillez renseigner un commentaire</span>
            </div>
            <div class="mcf-page-line-cell mcf-page-line-edit">
              <label class="mcf-page-line-subtitle">Signature</label>
              <span v-if="form.signature_data==''">Veuillez renseigner une signature</span>
            </div>
            <div class="mcf-page-line-cell">
              <table class="mcf-table-totaux">
                <tr>
                  <td>Total HT</td>
                  <td>{{$filters.money(form.sub_total,lang)}}</td>
                </tr>
                <tr v-if="form.tax_number>=1">
                  <td @click="bt_edit('tax1')">{{form.tax1_label}} {{ form.tax1_rate }}%<label v-if="form.tax1_is_included"> (incluse)</label></td>
                  <td>{{$filters.money(form.tax1_total,lang)}}</td>
                </tr>
                <tr v-if="form.tax_number>=2">
                  <td @click="bt_edit('tax2')">{{form.tax2_label}} {{ form.tax2_rate }}%<label v-if="form.tax2_is_included"> (incluse)</label></td>
                  <td>{{$filters.money(form.tax2_total,lang)}}</td>
                </tr>
                <tr v-if="form.tax_number>=3">
                  <td @click="bt_edit('tax3')">{{form.tax3_label}} {{ form.tax3_rate }}%<label v-if="form.tax3_is_included"> (incluse)</label></td>
                  <td>{{$filters.money(form.tax3_total,lang)}}</td>
                </tr>
                <tr>
                  <td style="font-size:16px;border-top:solid 2px var(--C2);">Total TTC</td>
                  <td style="font-size:16px;border-top:solid 2px var(--C2);border-bottom:solid 2px var(--C2);">{{$filters.money(form.total_ttc,lang)}}</td>
                </tr>
                <tr v-if="form.label!='LBL_CREDIT'">
                  <td>Acomptes</td>
                  <td>{{$filters.money(form.total_advances,lang)}}</td>
                </tr>
                <tr v-if="form.label!='LBL_CREDIT'">
                  <td>Règlements</td>
                  <td>{{$filters.money(form.total_payments,lang)}}</td>
                </tr>
                <tr v-if="form.label!='LBL_CREDIT'">
                  <td style="font-size:16px;border-top:solid 2px var(--C2);">Net à payer</td>
                  <td style="font-size:16px;border-top:solid 2px var(--C2);">{{$filters.money(form.total_ltp,lang)}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div style="margin-top:20px;" class="mcf-page-line-1" v-if="form.label!='LBL_CREDIT'">
            <div class="mcf-page-line-title">
              <h1><i class='fa fa-user'></i> Règlements</h1>
            </div>
          </div>
          <div style="margin-top:20px;margin-bottom:20px;" class="mcf-page-line-1" v-if="form.label!='LBL_CREDIT'">
            <table class="mcf-table-salelines">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Méthode</th>
                  <th>Montant</th>
                  <th class="mcf-table-salelines-text">Description</th>
                  <th style="width:32px;text-align:center;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="line of form.lists.payments" :key="line.id">
                  <template v-if="line.is_deleted==0">
                    <td style="padding:5px;text-align:center;" class="mcf-table-salelines-number">{{$filters.mdate(line.payment_date,lang)}}</td>
                    <td style="padding:5px;text-align:center;" class="mcf-table-salelines-number">{{line.method}}</td>
                    <td style="padding:5px;text-align:right;" class="mcf-table-salelines-number">{{$filters.money(line.amount,lang)}}</td>
                    <td style="padding:5px;text-align:left;white-space: pre-wrap;word-break: break-word;">{{line.note}}</td>
                    <td @click="bt_delete_payment(line);" style="width:32px;text-align:center;cursor:pointer;color:red;"><i class='fa fa-trash'></i></td>
                  </template>
                  <template v-if="line.is_deleted==1">
                    <td style="text-decoration: line-through;color:gray;padding:5px;text-align:center;" class="mcf-table-salelines-number">{{$filters.mdate(line.payment_date,lang)}}</td>
                    <td style="text-decoration: line-through;color:gray;padding:5px;text-align:center;" class="mcf-table-salelines-number">{{line.method}}</td>
                    <td style="text-decoration: line-through;color:gray;padding:5px;text-align:right;" class="mcf-table-salelines-number">{{$filters.money(line.amount,lang)}}</td>
                    <td style="color:gray;padding:5px;text-align:left;white-space: pre-wrap;word-break: break-word;">{{line.note}}</td>
                    <td style="width:32px;text-align:center;cursor:pointer;color:gray;"><i class='fa fa-trash'></i></td>
                  </template>
                </tr>
              </tbody>
              <tbody v-if="form.lists.payments.length==0">
                <tr>
                  <td style="border:solid 1px var(--TEXT);text-align:center;padding:20px;" colspan="8"><i class='fa fa-plus'></i> Ajouter un règlement</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <invoices_edit v-if="app_action=='edit'" :view="edit_view" :account="account" :invoice="form_tmp" :cancel="evt_edit_cancel" :save="evt_edit_save"></invoices_edit>
    <invoices_edit_line v-if="app_action=='edit_line'" :account="account" :invoice="form" :line="form_tmp" :cancel="evt_edit_cancel" :save="evt_edit_line_save"></invoices_edit_line>
    <invoices_discount v-if="app_action=='edit_discount'" :line="form_tmp" :cancel="evt_edit_cancel" :save="evt_edit_discount_save"></invoices_discount>
    <invoices_payment v-if="app_action=='edit_payment'" :invoice="form" :payment="form_tmp" :cancel="evt_edit_cancel" :save="evt_edit_payment_save"></invoices_payment>
    <uicustomers v-if="app_action=='customers'" :account="account" :select="evt_customer_select" :cancel="evt_edit_cancel"></uicustomers>
    <uiproducts v-if="app_action=='products'" :account="account" :select="evt_product_select" :cancel="evt_edit_cancel"></uiproducts>
    <uploadfilebox v-if="app_action=='upload'" :setting="dialog_setting"></uploadfilebox>
    <pdfbox v-if="app_action=='print'" :setting="dialog_setting" :close="evt_edit_cancel"></pdfbox>
    <dialogbox v-if="dialog_show" :setting="dialog_setting"></dialogbox>
    <loadingbox v-if="loading"></loadingbox>
  </div>
</template>

<script>
import {VueDraggableNext} from 'vue-draggable-next';
import apiaccount from "../../core/data/account";
import tools from "../../core/data/tools";
import translation from "../../core/data/lang";
import apiinvoice from "../../core/data/invoice";
import apiproduct from "../../core/data/product";
// import apicustomer from "../../core/data/customer";
import dialogbox from "../../core/controls/ui-dialogbox";
import loadingbox from "../../core/controls/ui-loadingbox";
import pdfbox from "../../core/controls/ui-pdfbox";
import uploadfilebox from "../../core/controls/ui-uploadfilebox";
import uicustomers from "../../core/controls/ui-customers";
import uiproducts from "../../core/controls/ui-products";
import invoices_edit from "./invoices-edit.vue";
import invoices_edit_line from "./invoices-edit-line.vue";
import invoices_discount from "./invoices-discount.vue";
import invoices_payment from "./invoices-payment.vue";
import {DateTime} from "luxon";

export default {
  components:{ 
    draggable: VueDraggableNext,
    dialogbox,loadingbox,pdfbox,uploadfilebox,invoices_edit,invoices_edit_line,invoices_discount,invoices_payment,uicustomers,uiproducts
  },
  data(){
    return {
      loading:false,
      is_drag:true,
      lang:'fr-FR',
      dialog_show:false,
      dialog_setting:{},
      app_action:'',
      edit_view:'',
      title:'Factures',
      account:{},
      txtsearch:'',
      logo:"",
      form:{},
      form_tmp:{}
    }
  },
  computed: {
    is_form_active: function(){
      return (JSON.stringify(this.form) != '{}');
    },
    is_editable: function(){
      var info = false;
      if (JSON.stringify(this.form)!='{}'){
        info = (this.form.invoice_number=='XXXXXXXX');
      }
      return info;
    },
    is_enable_payment: function(){
      var info = false;
      if (JSON.stringify(this.form)!='{}'){
        info = (this.form.invoice_number!='XXXXXXXX' && this.form.total_ltp >0 && this.form.state!='INV_LBL_SOLD');
      }
      return info;
    },
    is_enable_credit: function(){
      var info = false;
      if (JSON.stringify(this.form)!='{}'){
        info = (this.form.label!='LBL_CREDIT' && this.form.lists.lines.length>0);
      }
      return info;
    },
    is_origin: function(){
      var info = false;
      if (JSON.stringify(this.form)!='{}'){
        info = (this.form.lists.origin.length>0);
      }
      return info;
    },
    is_links: function(){
      var info = false;
      if (JSON.stringify(this.form)!='{}'){
        info = (this.form.id_sale!='00000000-0000-0000-0000-000000000000' || this.form.id_invoice!='00000000-0000-0000-0000-000000000000');
      }
      return info;
    },
    lg: function(){
      return translation.get(this.lang);
    },
    total_payments: function(){
      var tot = 0;
      for(var p of this.form.lists.payments){
        tot+=p.amount;
      }
      return Number(tot);
    },
    total_advances: function(){
      var tot = 0;
      for(var p of this.form.lists.advances){
        tot+=p.total_ttc;
      }
      return Number(tot);
    },
    list_draggable: 
    {
      get() {
        return this.form.lists.lines;
      },
      set(value){
        this.list_update(value);
      }
        
    }
  },
  created: async function(){
    var tmain = this;
    tmain.loading = true;
    tools.set_title('Macrofox - Factures');
    tools.set_background('light');
    tools.set_theme('blue');
    var pkg = await apiaccount.info();
    if (pkg.code==0){
      tmain.account = pkg.data;
      if (localStorage.getItem("id")!=undefined){
        var pget = await apiinvoice.get(localStorage.getItem("id"));
        if (pget.code==0){
          tmain.form = pget.data;
          tmain.loading = false;
        }
      }else{
        tmain.$router.push({path:'/home'});
      }
    }else{
      tmain.$router.push({path:'/'});
    }
  },
  methods:{
    list_update:async function(list){
      var tmain = this;
      console.log(list);
      var i = 0;
      for(var item of list){
        tmain.form.lists.lines.filter(x=>x.id==item.id)[0].index_line=i;
        i++;
      }
      tmain.loading = true;
      await apiinvoice.save(tmain.form);
      var pget = await apiinvoice.get(localStorage.getItem("id"));
      if (pget.code==0){
        tmain.form = pget.data;
      }
      tmain.loading = false;
    },
    change_theme: async function(){
      this.account.theme = (this.account.theme=='light' ? 'dark' : 'light');
      var pkg = await apiaccount.update(this.account);
      if (pkg.code==0){
        tools.set_background(this.account.theme);
      }      
    },
    bt_new: async function(){
      var tmain = this;
      tmain.dialog_setting = {
        icon:'fa fa-plus',
        title:'Nouveau',
        message:'Voulez-vous créer une facture ?',
        buttons:[
          {
            label:'Oui',
            fx:async function(){
              var pkg = await apiinvoice.new('');
              if (pkg.code==0){
                tmain.form = pkg.data;
                tmain.form_tmp = {};
                tmain.dialog_setting = {};
                tmain.dialog_show=false;
                tmain.logo ="";
                localStorage.setItem("id",tmain.form.id);
              }
            }
          },
          {
            label:'Non',
            fx:function(){
              tmain.dialog_show=false;
            }
          }
        ]
      };
      tmain.dialog_show=true;
    },
    bt_edit: function(view){
      var tmain = this;
      tmain.form.cust_account_number = (tmain.form.cust_account_number=='' ? '411000' : tmain.form.cust_account_number);
      tmain.form.cust_billingcompany = (tmain.form.cust_billingcompany=='' ? 'Client de passage' : tmain.form.cust_billingcompany);
      tmain.form.cust_deliverycompany = (tmain.form.cust_deliverycompany=='' ? 'Client de passage' : tmain.form.cust_deliverycompany);
      tmain.form_tmp = Object.assign({},tmain.form);
      tmain.edit_view = view;
      tmain.app_action="edit";
    },
    bt_edit_line: function(line){
      var tmain = this;
      tmain.form_tmp = Object.assign({},line);
      tmain.app_action="edit_line";
    },
    bt_print: async function(){
      var tmain = this;
      tmain.loading = true;
      var pkgfile = await apiinvoice.print('INVOICE',tmain.form.id);
      var fileURL = window.URL.createObjectURL(new Blob([pkgfile],{ type: 'application/pdf' }));
      tmain.loading=false;
      tmain.app_action = 'print';
      tmain.dialog_setting = {
        icon:'fa fa-print',
        title:tmain.form.invoice_number + " - " + tmain.form.cust_billingcompany + " - " + DateTime.fromSQL(tmain.form.invoice_date,{locale:'fr'}).toFormat('MMMM yyyy'),
        data:fileURL,
        buttons:[]
      };
    },
    bt_delete:async function(){
      var tmain = this;
      if (tmain.is_editable){
        tmain.dialog_setting = {
          icon:'fa fa-trash',
          title:'Supprimer',
          message:'Voulez-vous supprimer cette facture '+tmain.form.invoice_number+' ?',
          buttons:[
            {
              label:'Oui',
              fx:async function(){
                var pkg = await apiinvoice.delete([{id:tmain.form.id}]);
                if (pkg.code==0){
                  if (pkg.data.length>0){
                    alert('impossible de supprimer ce document');
                  }else{
                    tmain.form = {};
                    tmain.form_tmp = {};
                    tmain.dialog_setting = {};
                    localStorage.clear();
                    tmain.dialog_show=false;
                  }
                }
              }
            },
            {
              label:'Non',
              fx:function(){
                tmain.dialog_show=false;
              }
            }
          ]
        };
        tmain.dialog_show=true;
      }
    },
    bt_validate:async function(){
      var tmain = this;
      if (tmain.form.invoice_number=='XXXXXXXX' && tmain.form.lists.lines.length>0){
        tmain.dialog_setting = {
          icon:'fa fa-check',
          title:'Validation',
          message:'Voulez-vous valider cette facture ?',
          buttons:[
            {
              label:'Oui',
              fx:async function(){
                var pkg = await apiinvoice.validate(tmain.form.id);
                if (pkg.code==0){
                  var pkgget = await apiinvoice.get(tmain.form.id);
                  if (pkgget.code==0){
                    tmain.form = pkgget.data;          
                  }else{
                    console.log('error');
                  }
                }
                tmain.dialog_show=false;
              }
            },
            {
              label:'Non',
              fx:function(){
                tmain.dialog_show=false;
              }
            }
          ]
        };
        tmain.dialog_show=true;
      }
    },
    bt_customer_selection: function(){
      var tmain = this;
      if (tmain.is_editable){
        tmain.app_action="customers";
      }
    },
    bt_customer_fast: function(){
      var tmain = this;
      if (tmain.is_editable){
        if (tmain.form.id_customer!='00000000-0000-0000-0000-000000000000'){
          tmain.dialog_setting = {
            icon:'fa fa-info',
            title:'Information',
            message:'Vous aviez sélectionné un client en compte. Voulez-vous renseigner un client de passage ?',
            buttons:[
              {
                label:'Oui',
                fx:async function(){
                  tmain.dialog_show=false;
                  tmain.form.id_customer = '00000000-0000-0000-0000-000000000000';
                  tmain.form.cust_account_number = '411000';
                  tmain.form.cust_email = '';
                  tmain.form.cust_siret = '';
                  tmain.form.cust_ape_code = '';
                  tmain.form.cust_vat_identication = '';
                  tmain.form.cust_billingcompany = 'Client de passage';
                  tmain.form.cust_billingaddress1 = '';
                  tmain.form.cust_billingaddress2 = '';
                  tmain.form.cust_billingaddress3 = '';
                  tmain.form.cust_billingzipcode = '';
                  tmain.form.cust_billingcity = '';
                  tmain.form.cust_billingcountry = '';
                  tmain.form.cust_billingphone = '';
                  tmain.form.cust_deliverycompany = 'Client de passage';
                  tmain.form.cust_deliveryaddress1 = '';
                  tmain.form.cust_deliveryaddress2 = '';
                  tmain.form.cust_deliveryaddress3 = '';
                  tmain.form.cust_deliveryzipcode = '';
                  tmain.form.cust_deliverycity = '';
                  tmain.form.cust_deliverycountry = '';
                  tmain.form.cust_deliveryphone = '';
                  tmain.bt_edit('customer');
                }
              },
              {
                label:'Non',
                fx:function(){
                  tmain.dialog_show=false;
                }
              }
            ]
          };
          tmain.dialog_show=true;
        }else{
          tmain.bt_edit('customer');
        }
      }
    },
    bt_add_line:async function(){
      var tmain = this;
      if (tmain.is_editable){
        tmain.loading = true;
        tmain.form_tmp = {};
        tmain.app_action = "";
        var pkg = await apiinvoice.line_new_fast(tmain.form.id);
        if (pkg.code==0){
          tmain.form_tmp = pkg.data;
          tmain.app_action = 'edit_line';
        }else{
          console.log('error');
        }
        tmain.loading = false;
      }
    },
    bt_add_products:async function(){
      var tmain = this;
      if (tmain.is_editable){
        tmain.app_action="products";
      }
    },
    bt_add_comment:async function(){
      var tmain = this;
      if (tmain.is_editable){
        tmain.loading = true;        
        tmain.form_tmp = {};
        tmain.app_action = "";
        var pkg = await apiinvoice.line_comment(tmain.form.id);
        if (pkg.code==0){
          tmain.form_tmp = pkg.data;
          tmain.app_action = 'edit_line';
        }else{
          console.log('error');
        }
        tmain.loading = false;
      }
    },
    bt_edit_discount:async function(){
      var tmain = this;
      if (tmain.is_editable){
        tmain.form_tmp = {discount_type:'PERCENT',discount_amount:0};
        tmain.app_action = 'edit_discount';
      }
    },
    bt_add_payment:async function(){
      var tmain = this;
      if (tmain.is_enable_payment){
        var vdate = DateTime.now().toFormat('yyyy-MM-dd');
        tmain.form_tmp = {action:'add',amount:tmain.form.total_ltp,method:tmain.form.terms_condition,payment_date:vdate,note:''};
        tmain.app_action = 'edit_payment';
      }
    },
    bt_delete_payment: async function(item){
      var tmain = this;
      tmain.dialog_setting = {
        icon:'fa fa-info',
        title:'Information',
        message:'Voulez-vous supprimer ce règlement ?',
        buttons:[
          {
            label:'Oui',
            fx:function(){
              tmain.dialog_show=false;
              item.action = 'edit';
              tmain.form_tmp = item;
              tmain.app_action = 'edit_payment';
            }
          },
          {
            label:'Non',
            fx:function(){
              tmain.dialog_show=false;
            }
          }
        ]
      };
      tmain.dialog_show=true;
    },
    bt_credit: async function(){
      var tmain = this;
      if (this.is_enable_credit){
        tmain.dialog_setting = {
          icon:'fa fa-file-invoice',
          title:'Avoir',
          message:'Voulez-vous créer un avoir sur la facture '+tmain.form.invoice_number+' ?',
          buttons:[
            {
              label:'Oui',
              fx:async function(){
                tmain.dialog_show=false;
                tmain.loading = true;
                var pkg = await apiinvoice.credit(tmain.form.id);
                if (pkg.code==0){
                  localStorage.setItem("id",pkg.data.id);
                  var pget = await apiinvoice.get(pkg.data.id);
                  if (pget.code==0){
                    tmain.form = pget.data;
                  }
                }
                tmain.loading = false;
              }
            },
            {
              label:'Non',
              fx:function(){
                tmain.dialog_show=false;
              }
            }
          ]
        };
        tmain.dialog_show=true;
      }
    },
    bt_state: async function(state){
      var tmain = this;
      tmain.dialog_setting = {
        icon:'fa fa-info',
        title:'Etat',
        message:'Voulez-vous changer l\'état de ce document '+tmain.form.sale_number+' ?',
        buttons:[
          {
            label:'Oui',
            fx:async function(){
              tmain.loading = true;
              switch(state){
                case "lost":
                  var pkg = await apiinvoice.state_lost([tmain.form]);
                  if (pkg.code==0){
                    if (pkg.data.length==0){
                      var pkgget = await apiinvoice.get(tmain.form.id);
                      if (pkgget.code==0){
                        tmain.form = pkgget.data;          
                      }else{
                        console.log('error');
                      }
                    }else{
                      alert(JSON.stringify(pkg.data));
                    }            
                  }else{
                    console.log('erreur');
                  }
                  break;
                case "running":
                  if (tmain.form.lists.invoices.length>0){
                    alert("facture existante");
                  }else{
                    tmain.form.state = 'SAL_LBL_RUNNING';
                    tmain.evt_edit_save(tmain.form);
                  }
                  break;
                case "sold":
                  alert("vous devez facturer le devis :-)");
                  break;
              }
              tmain.loading = false;
              tmain.dialog_show=false;
            }
          },
          {
            label:'Non',
            fx:function(){
              tmain.dialog_show=false;
            }
          }
        ]
      };
      tmain.dialog_show=true;
    },
    bt_view_sale: async function(origin){
      localStorage.setItem("id",origin.id);
      this.$router.push({path:'/sale'});
    },
    bt_view_invoice: async function(id){
      var tmain = this;
      localStorage.setItem("id",id);
      var pget = await apiinvoice.get(localStorage.getItem("id"));
        if (pget.code==0){
          tmain.form = pget.data;
          tmain.loading = false;
        }
    },
    bt_close: function(){
      var tmain = this;
      tmain.$router.push({path:'/home'});
    },
    evt_edit_cancel:function(){
      this.form_tmp={};
      this.app_action='';
    },
    evt_customer_select: async function(c){
      var tmain = this;
      tmain.loading = true;
      tmain.form_tmp = {};
      tmain.app_action = "";
      tmain.form.id_customer = c.id;
      tmain.form.cust_account_number = c.account_number;
      tmain.form.cust_email = c.email;
      tmain.form.cust_siret = c.siret;
      tmain.form.cust_ape_code = c.ape_code;
      tmain.form.cust_vat_identication = c.vat_identication;
      tmain.form.terms_condition = c.terms_condition;
      tmain.form.terms_nb = c.terms_nb;
      tmain.form.terms_delay = c.terms_delay;
      tmain.form.terms_day_due = c.terms_day_due;
      tmain.form.cust_billingcompany = c.billingcompany;
      tmain.form.cust_billingaddress1 = c.billingaddress1;
      tmain.form.cust_billingaddress2 = c.billingaddress2;
      tmain.form.cust_billingaddress3 = c.billingaddress3;
      tmain.form.cust_billingzipcode = c.billingzipcode;
      tmain.form.cust_billingcity = c.billingcity;
      tmain.form.cust_billingcountry = c.billingcountry;
      tmain.form.cust_billingphone = c.billingphone;
      tmain.form.cust_deliverycompany = c.deliverycompany;
      tmain.form.cust_deliveryaddress1 = c.deliveryaddress1;
      tmain.form.cust_deliveryaddress2 = c.deliveryaddress2;
      tmain.form.cust_deliveryaddress3 = c.deliveryaddress3;
      tmain.form.cust_deliveryzipcode = c.deliveryzipcode;
      tmain.form.cust_deliverycity = c.deliverycity;
      tmain.form.cust_deliverycountry = c.deliverycountry;
      tmain.form.cust_deliveryphone = c.deliveryphone;
      var pkg = await apiinvoice.save(tmain.form);
      if (pkg.code==0){
        var pkgget = await apiinvoice.get(tmain.form.id);
        if (pkgget.code==0){
          tmain.form = pkgget.data;          
        }else{
          console.log('error');
        }
      }else{
        console.log('error');
      }
      tmain.loading = false;
    },
    evt_edit_save: async function(item){
      var tmain = this;
      tmain.loading = true;
      tmain.form_tmp = {};
      tmain.app_action = "";
      var pkg = await apiinvoice.save(item);
      if (pkg.code==0){
        var pkgget = await apiinvoice.get(item.id);
        if (pkgget.code==0){
          tmain.form = pkgget.data;          
        }else{
          console.log('error');
        }
      }else{
        console.log('error');
      }
      tmain.loading = false;
    },
    evt_edit_line_save: async function(item){
      var tmain = this;
      tmain.loading = true;
      tmain.form_tmp = {};
      tmain.app_action = "";
      var pkg = await apiinvoice.line_save(item);
      if (pkg.code==0){
        var pkgget = await apiinvoice.get(tmain.form.id);
        if (pkgget.code==0){
          tmain.form = pkgget.data;          
        }else{
          console.log('error');
        }
      }else{
        console.log('error');
      }
      tmain.loading = false;
    },
    evt_edit_discount_save: async function(pkgdiscount){
      var tmain = this;
      tmain.loading = true;
      tmain.form_tmp = {};
      tmain.app_action = "";
      for(var l of tmain.form.lists.lines){
        l.discount_type = pkgdiscount.discount_type;
        l.discount_amount = pkgdiscount.discount_amount;
      }
      var pkg = await apiinvoice.save(tmain.form);
      if (pkg.code==0){
        var pkgget = await apiinvoice.get(tmain.form.id);
        if (pkgget.code==0){
          tmain.form = pkgget.data;          
        }else{
          console.log('error');
        }
      }else{
        console.log('error');
      }
      tmain.loading = false;
    },
    evt_edit_payment_save: async function(payment){
      var tmain = this;
      tmain.loading = true;
      tmain.form_tmp = {};
      tmain.app_action = "";
      var pkg = {};
      if (payment.action == 'add'){
        pkg = await apiinvoice.payment_save(tmain.form.id,payment);
      }
      if (payment.action == 'edit'){
        pkg = await apiinvoice.payment_delete(payment.id,payment.note);
      }
      if (pkg.code==0){
        var pkgget = await apiinvoice.get(tmain.form.id);
        if (pkgget.code==0){
          tmain.form = pkgget.data;
        }else{
          console.log('error');
        }
        tmain.loading = false;
      }else{
        if (pkg.code==2){
          tmain.dialog_setting = {
            icon:'fa fa-info',
            title:'Information',
            message:'Le montant de votre règlement est supérieur au restant dû de votre facture.',
            buttons:[
              {
                label:'OK',
                fx:function(){
                  tmain.dialog_show=false;
                }
              }
            ]
          };
          tmain.dialog_show=true;
        }
        tmain.loading = false;
      }
      
    },
    evt_product_select: async function(list){
      var tmain = this;
      tmain.loading = true;
      tmain.form_tmp = {};
      tmain.app_action = "";
      var pkg = await apiinvoice.line_new(tmain.form.id,list);
      if (pkg.code==0){
        var pkgget = await apiinvoice.get(tmain.form.id);
        if (pkgget.code==0){
          tmain.form = pkgget.data;          
        }else{
          console.log('error');
        }
      }else{
        console.log('error');
      }
      tmain.loading = false;
    },
    evt_search_enter: async function(){
      var tmain = this;
      //var pkgcustomer = await apicustomer.list();
      tmain.loading=true;
      if (tmain.form.invoice_number=='XXXXXXXX'){
        var pkgproduct = await apiproduct.list_selection();
        if (pkgproduct.data.length>0){
          var findproduct = pkgproduct.data.filter(x=>x.qrcode==tmain.txtsearch);
          if (findproduct.length==1){
            if (findproduct[0].qtycmd < findproduct[0].qtydispo){
              var alreadyexist = tmain.form.lists.lines.filter(x=>x.id_product==findproduct[0].id);
              if (alreadyexist.length==1){
                alreadyexist[0].qty += 1;
                await apiinvoice.line_save(alreadyexist[0]);
              }else{
                findproduct[0].qtycmd = 1;
                await apiinvoice.line_new(tmain.form.id,[findproduct[0]]);
              }
              var pkgget = await apiinvoice.get(tmain.form.id);
              if (pkgget.code==0){
                tmain.form = pkgget.data;
              }else{
                console.log('error');
              }
            }
            tmain.txtsearch = "";
          }
        }
      }
      tmain.loading = false;
    }
  }
}
</script>
<!-- 
<style scoped>

.prod-header{
    padding:20px;
    text-align:left;
}

.prod-header>h1{
    font-size:20px;
    color:var(--C1);
}

.prod-header>label{
    font-size:12px;
}

.prod-logo{
  height: 100%;
  width:100%;
}

.prod-logo-empty{
  border:solid 1px #ddd;
  border-radius: 5px;
  width:calc(100% - 40px);
  height:calc(100% - 40px);
  margin-right:20px;
  margin-left:20px;
  margin-top:20px;
  text-align:center;
  min-height:70px;
  display:grid;
  align-items: center;
}

.prod-logo-empty i{
  color:var(--C2);
  /* margin-top:20px; */
}

.prod-logo-empty label{
  font-size:12px;
}

.prod-logo-content{
  border:solid 1px #ddd;
  border-radius: 5px;
  width:calc(100% - 40px);
  height:calc(100% - 40px);
  margin-right:20px;
  margin-left:20px;
  margin-top:20px;
  text-align:center;
}

.prod-logo-content>img{
  width: auto;
  height: 100%;
  max-width: 180px;
  object-fit: contain;
}

.prod-mcf-page-line-cell{
  background-color:var(--C3);
  border:solid 1px var(--C2);
  border-radius:5px;
  margin:20px;
  padding-bottom:7px;
  display:grid;
  grid-template-rows: 30px auto;
}

.prod-mcf-page-line-cell>label{
  align-self: center;
  justify-self: center;  
}

.prod-mcf-page-line-cell>span{
  align-self: center;
  justify-self: center;
  font-size:20px;
  color:var(--C2);
}

</style> -->